export default {

    getTableHeader(){
        return {
            textAlign: "center",
            background: "#f8f8f8",
            color: "#232323",
        }
    },
  // 下拉搜索
  setOption(queryString, cb, list) {
    // var optionStaff = this.optionStaff;
    var results = queryString ? list.filter(this.createFilter(queryString)) : list;
    console.log(results)
    // 调用 callback 返回建议列表的数据
    cb(results);
  },
  createFilter(queryString) {
    return (restaurant) => {
      return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    };
  },
  headClass() {
    return 'text-align: center;'
  },
    // 广告套利-报告-格式化时间
    adReportSetTime(time){
        const date = new Date(time);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedTime = `${year}-${month}-${day}`
        return formattedTime
    },
    // 格式化公共方法
    setTime(time) {
        const date = new Date(time);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const formattedTime = `${year}-${month}-${day} ${hour}:${minute}:${seconds}`
        return formattedTime
    },
  // 广告逃离-offers管理获取货币
  getCurrencyList() {
    let list = {
      AED: '',
      AFN: '',
      ALL: '',
      AMD: '',
      ANG: '',
      AOA: '',
      ARS: '',
      AUD: '',
      AWG: '',
      AZN: '',
      BAM: '',
      BBD: '',
      BDT: '',
      BGN: '',
      BHD: '',
      BIF: '',
      BMD: '',
      BND: '',
      BOB: '',
      BOV: '',
      BRL: '',
      BSD: '',
      BTN: '',
      BWP: '',
      BYR: '',
      BZD: '',
      CAD: '',
      CDF: '',
      CHE: '',
      CHF: '',
      CHW: '',
      CLF: '',
      CLP: '',
      CNY: '',
      COP: '',
      COU: '',
      CRC: '',
      CUC: '',
      CUP: '',
      CVE: '',
      CZK: '',
      DJF: '',
      DKK: '',
      DOP: '',
      DZD: '',
      EGP: '',
      ERN: '',
      EUR: '',
      FJD: '',
      FKP: '',
      GBP: '',
      GEL: '',
      GHS: '',
      GIP: '',
      GMD: '',
      GNF: '',
      GTQ: '',
      GYD: '',
      HKD: '',
      HNL: '',
      HRK: '',
      HTG: '',
      HUF: '',
      IDR: '',
      ILS: '',
      INR: '',
      IQD: '',
      IRR: '',
      ISK: '',
      JMD: '',
      JOD: '',
      JPY: '',
      KES: '',
      KGS: '',
      KHR: '',
      KMF: '',
      KPW: '',
      KRW: '',
      KWD: '',
      KYD: '',
      KZT: '',
      LAK: '',
      LBP: '',
      LKR: '',
      LRD: '',
      LSL: '',
      LTL: '',
      LVL: '',
      LYD: '',
      MAD: '',
      MDL: '',
      MGA: '',
      MKD: '',
      MMK: '',
      MNT: '',
      MOP: '',
      MRO: '',
      MUR: '',
      MVR: '',
      MWK: '',
      MXN: '',
      MXV: '',
      MYR: '',
      MZN: '',
      NAD: '',
      NGN: '',
      NIO: '',
      NOK: '',
      NPR: '',
      NZD: '',
      OMR: '',
      PAB: '',
      PEN: '',
      PGK: '',
      PHP: '',
      PKR: '',
      PLN: '',
      PYG: '',
      QAR: '',
      RON: '',
      RSD: '',
      RUB: '',
      RWF: '',
      SAR: '',
      SBD: '',
      SCR: '',
      SDG: '',
      SEK: '',
      SGD: '',
      SHP: '',
      SLL: '',
      SOS: '',
      SRD: '',
      SSP: '',
      STD: '',
      SYP: '',
      SZL: '',
      THB: '',
      TJS: '',
      TMT: '',
      TND: '',
      TOP: '',
      TRY: '',
      TTD: '',
      TWD: '',
      TZS: '',
      UAH: '',
      UGX: '',
      USD: '',
      USN: '',
      USS: '',
      UYI: '',
      UYU: '',
      UZS: '',
      VEF: '',
      VND: '',
      VUV: '',
      WST: '',
      XAF: '',
      XAG: '',
      XAU: '',
      XBA: '',
      XBB: '',
      XBC: '',
      XBD: '',
      XCD: '',
      XDR: '',
      XFU: '',
      XOF: '',
      XPD: '',
      XPF: '',
      XPT: '',
      XTS: '',
      XXX: '',
      YER: '',
      ZAR: '',
      ZMW: ''
    }
    return list
  },
  // 广告套利-campaigns管理-获取costType
  getCostTypeList(){
    let list = [
      name = 'no_tracked',
      name = 'cpc',
      name = 'cpm',
      name = 'cpa',
      name = 'revshare',
      name = 'auto_cpi'
    ]
    return list
  },
  // 广告套利-campaigns管理-获取deviceType
  getDeviceTypeList(){
    let list = [
      name = '全部',
      name = 'DesktopLaptops',
      name = 'MobilePhones',
      name = 'SmartTV',
      name = 'Tablet'
    ]
    return list
  },
  // 广告套利-campaigns管理-获取country
  getCountryList(){
    let list = [
      name = '全球',
      name = 'Andorra',
      name = 'United Arab Emirates',
      name = 'Afghanistan',
      name = 'Antigua And Barbuda',
      name = 'Anguilla',
      name = 'Albania',
      name = 'Armenia',
      name = 'Angola',
      name = 'Antarctica',
      name = 'Argentina',
      name = 'American Samoa',
      name = 'Austria',
      name = 'Australia',
      name = 'Aruba',
      name = 'Åland Islands',
      name = 'Azerbaijan',
      name = 'Bosnia And Herzegovina',
      name = 'Barbados',
      name = 'Bangladesh',
      name = 'Belgium',
      name = 'Burkina Faso',
      name = 'Bulgaria',
      name = 'Bahrain',
      name = 'Burundi',
      name = 'Benin',
      name = 'Saint Barthélemy',
      name = 'Bermuda',
      name = 'Brunei Darussalam',
      name = 'Bolivia',
      name = 'Bonaire, Sint Eustatius And Saba',
      name = 'Brazil',
      name = 'Bahamas',
      name = 'Bhutan',
      name = 'Bouvet Island',
      name = 'Botswana',
      name = 'Belarus',
      name = 'Belize',
      name = 'Canada',
      name = 'Cocos (Keeling) Islands',
      name = 'Democratic Republic of the Congo',
      name = 'Central African Republic',
      name = 'Congo',
      name = 'Switzerland',
      name = 'Côte DIvoire',
      name = 'Cook Islands',
      name = 'Chile',
      name = 'Cameroon',
      name = 'China',
      name = 'Colombia',
      name = 'Costa Rica',
      name = 'Cuba',
      name = 'Cape Verde',
      name = 'Curaçao',
      name = 'Christmas Island',
      name = 'Cyprus',
      name = 'Czech Republic',
      name = 'Germany',
      name = 'Djibouti',
      name = 'Denmark',
      name = 'Dominica',
      name = 'Dominican Republic',
      name = 'Algeria',
      name = 'Ecuador',
      name = 'Estonia',
      name = 'Egypt',
      name = 'Western Sahara',
      name = 'Eritrea',
      name = 'Spain',
      name = 'Ethiopia',
      name = 'Finland',
      name = 'Fiji',
      name = 'Falkland Islands (Malvinas)',
      name = 'Federated States Of Micronesia',
      name = 'Faroe Islands',
      name = 'France',
      name = 'Gabon',
      name = 'United Kingdom',
      name = 'Grenada',
      name = 'Georgia',
      name = 'French Guiana',
      name = 'Guernsey',
      name = 'Ghana',
      name = 'Gibraltar',
      name = 'Greenland',
      name = 'Gambia',
      name = 'Guinea',
      name = 'Guadeloupe',
      name = 'Equatorial Guinea',
      name = 'Greece',
      name = 'South Georgia And The South Sandwich Islands',
      name = 'Guatemala',
      name = 'Guam',
      name = 'Guinea-Bissau',
      name = 'Guyana',
      name = 'Hong Kong',
      name = 'Heard Island And Mcdonald Islands',
      name = 'Honduras',
      name = 'Croatia',
      name = 'Haiti',
      name = 'Hungary',
      name = 'Canary Islands',
      name = 'Indonesia',
      name = 'Ireland',
      name = 'Israel',
      name = 'Isle Of Man',
      name = 'India',
      name = 'British Indian Ocean Territory',
      name = 'Iraq',
      name = 'Iran',
      name = 'Iceland',
      name = 'Italy',
      name = 'Jersey',
      name = 'Jamaica',
      name = 'Jordan',
      name = 'Japan',
      name = 'Kenya',
      name = 'Kyrgyzstan',
      name = 'Cambodia',
      name = 'Kiribati',
      name = 'Comoros',
      name = 'Saint Kitts And Nevis',
      name = 'North Korea',
      name = 'South Korea',
      name = 'Kuwait',
      name = 'Cayman Islands',
      name = 'Kazakhstan',
      name = 'Lao PeopleS Democratic Republic',
      name = 'Lebanon',
      name = 'Saint Lucia',
      name = 'Liechtenstein',
      name = 'Sri Lanka',
      name = 'Liberia',
      name = 'Lesotho',
      name = 'Lithuania',
      name = 'Luxembourg',
      name = 'Latvia',
      name = 'Libya',
      name = 'Morocco',
      name = 'Monaco',
      name = 'Moldova',
      name = 'Montenegro',
      name = 'Saint Martin (French Part)',
      name = 'Madagascar',
      name = 'Marshall Islands',
      name = 'Macedonia',
      name = 'Mali',
      name = 'Myanmar',
      name = 'Mongolia',
      name = 'Macao',
      name = 'Northern Mariana Islands',
      name = 'Martinique',
      name = 'Mauritania',
      name = 'Montserrat',
      name = 'Malta',
      name = 'Mauritius',
      name = 'Maldives',
      name = 'Malawi',
      name = 'Mexico',
      name = 'Malaysia',
      name = 'Mozambique',
      name = 'Namibia',
      name = 'New Caledonia',
      name = 'Niger',
      name = 'Norfolk Island',
      name = 'Nigeria',
      name = 'Nicaragua',
      name = 'Netherlands',
      name = 'Norway',
      name = 'Nepal',
      name = 'Nauru',
      name = 'Niue',
      name = 'New Zealand',
      name = 'Oman',
      name = 'Panama',
      name = 'Peru',
      name = 'French Polynesia',
      name = 'Papua New Guinea',
      name = 'Philippines',
      name = 'Pakistan',
      name = 'Poland',
      name = 'Saint Pierre And Miquelon',
      name = 'Pitcairn',
      name = 'Puerto Rico',
      name = 'Palestine',
      name = 'Portugal',
      name = 'Palau',
      name = 'Paraguay',
      name = 'Qatar',
      name = 'Réunion',
      name = 'Romania',
      name = 'Serbia',
      name = 'Russian Federation',
      name = 'Rwanda',
      name = 'Saudi Arabia',
      name = 'Solomon Islands',
      name = 'Seychelles',
      name = 'Sudan',
      name = 'Sweden',
      name = 'Singapore',
      name = 'Saint Helena',
      name = 'Slovenia',
      name = 'Svalbard And Jan Mayen',
      name = 'Slovakia',
      name = 'Sierra Leone',
      name = 'San Marino',
      name = 'Senegal',
      name = 'Somalia',
      name = 'Suriname',
      name = 'South Sudan',
      name = 'Sao Tome And Principe',
      name = 'El Salvador',
      name = 'Sint Maarten (Dutch Part)',
      name = 'Syrian Arab Republic',
      name = 'Swaziland',
      name = 'Turks And Caicos Islands',
      name = 'Chad',
      name = 'French Southern Territories',
      name = 'Togo',
      name = 'Thailand',
      name = 'Tajikistan',
      name = 'Tokelau',
      name = 'Timor-Leste',
      name = 'Turkmenistan',
      name = 'Tunisia',
      name = 'Tonga',
      name = 'Turkey',
      name = 'Trinidad And Tobago',
      name = 'Tuvalu',
      name = 'Taiwan',
      name = 'Tanzania',
      name = 'Ukraine',
      name = 'Uganda',
      name = 'United States Minor Outlying Islands',
      name = 'United States',
      name = 'Uruguay',
      name = 'Uzbekistan',
      name = 'Holy See (Vatican City State)',
      name = 'Saint Vincent And The Grenadines',
      name = 'Venezuela',
      name = 'Virgin Islands, British',
      name = 'Virgin Islands, U.S.',
      name = 'Viet Nam',
      name = 'Vanuatu',
      name = 'Wallis And Futuna',
      name = 'Samoa',
      name = 'Yemen',
      name = 'Mayotte',
      name = 'South Africa',
      name = 'Zambia',
      name = 'Zimbabwe'
    ]
    return list
  },
  // 广告套利-报告-获取时区
  getTimeZoneList(){
    let list = [
      name = 'Africa/Abidjan',
      name = 'Africa/Accra',
      name = 'Africa/Addis_Ababa',
      name = 'Africa/Algiers',
      name = 'Africa/Asmara',
      name = 'Africa/Asmera',
      name = 'Africa/Bamako',
      name = 'Africa/Bangui',
      name = 'Africa/Banjul',
      name = 'Africa/Bissau',
      name = 'Africa/Blantyre',
      name = 'Africa/Brazzaville',
      name = 'Africa/Bujumbura',
      name = 'Africa/Cairo',
      name = 'Africa/Casablanca',
      name = 'Africa/Ceuta',
      name = 'Africa/Conakry',
      name = 'Africa/Dakar',
      name = 'Africa/Dar_es_Salaam',
      name = 'Africa/Djibouti',
      name = 'Africa/Douala',
      name = 'Africa/El_Aaiun',
      name = 'Africa/Freetown',
      name = 'Africa/Gaborone',
      name = 'Africa/Harare',
      name = 'Africa/Johannesburg',
      name = 'Africa/Juba',
      name = 'Africa/Kampala',
      name = 'Africa/Khartoum',
      name = 'Africa/Kigali',
      name = 'Africa/Kinshasa',
      name = 'Africa/Lagos',
      name = 'Africa/Libreville',
      name = 'Africa/Lome',
      name = 'Africa/Luanda',
      name = 'Africa/Lubumbashi',
      name = 'Africa/Lusaka',
      name = 'Africa/Malabo',
      name = 'Africa/Maputo',
      name = 'Africa/Maseru',
      name = 'Africa/Mbabane',
      name = 'Africa/Mogadishu',
      name = 'Africa/Monrovia',
      name = 'Africa/Nairobi',
      name = 'Africa/Ndjamena',
      name = 'Africa/Niamey',
      name = 'Africa/Nouakchott',
      name = 'Africa/Ouagadougou',
      name = 'Africa/Porto-Novo',
      name = 'Africa/Sao_Tome',
      name = 'Africa/Timbuktu',
      name = 'Africa/Tripoli',
      name = 'Africa/Tunis',
      name = 'Africa/Windhoek',
      name = 'America/Adak',
      name = 'America/Anchorage',
      name = 'America/Anguilla',
      name = 'America/Antigua',
      name = 'America/Araguaina',
      name = 'America/Argentina/Buenos_Aires',
      name = 'America/Argentina/Catamarca',
      name = 'America/Argentina/ComodRivadavia',
      name = 'America/Argentina/Cordoba',
      name = 'America/Argentina/Jujuy',
      name = 'America/Argentina/La_Rioja',
      name = 'America/Argentina/Mendoza',
      name = 'America/Argentina/Rio_Gallegos',
      name = 'America/Argentina/Salta',
      name = 'America/Argentina/San_Juan',
      name = 'America/Argentina/San_Luis',
      name = 'America/Argentina/Tucuman',
      name = 'America/Argentina/Ushuaia',
      name = 'America/Aruba',
      name = 'America/Asuncion',
      name = 'America/Atikokan',
      name = 'America/Atka',
      name = 'America/Bahia',
      name = 'America/Bahia_Banderas',
      name = 'America/Barbados',
      name = 'America/Belem',
      name = 'America/Belize',
      name = 'America/Blanc-Sablon',
      name = 'America/Boa_Vista',
      name = 'America/Bogota',
      name = 'America/Boise',
      name = 'America/Buenos_Aires',
      name = 'America/Cambridge_Bay',
      name = 'America/Campo_Grande',
      name = 'America/Cancun',
      name = 'America/Caracas',
      name = 'America/Catamarca',
      name = 'America/Cayenne',
      name = 'America/Cayman',
      name = 'America/Chicago',
      name = 'America/Chihuahua',
      name = 'America/Coral_Harbour',
      name = 'America/Cordoba',
      name = 'America/Costa_Rica',
      name = 'America/Creston',
      name = 'America/Cuiaba',
      name = 'America/Curacao',
      name = 'America/Danmarkshavn',
      name = 'America/Dawson',
      name = 'America/Dawson_Creek',
      name = 'America/Denver',
      name = 'America/Detroit',
      name = 'America/Dominica',
      name = 'America/Edmonton',
      name = 'America/Eirunepe',
      name = 'America/El_Salvador',
      name = 'America/Ensenada',
      name = 'America/Fort_Nelson',
      name = 'America/Fort_Wayne',
      name = 'America/Fortaleza',
      name = 'America/Glace_Bay',
      name = 'America/Godthab',
      name = 'America/Goose_Bay',
      name = 'America/Grand_Turk',
      name = 'America/Grenada',
      name = 'America/Guadeloupe',
      name = 'America/Guatemala',
      name = 'America/Guayaquil',
      name = 'America/Guyana',
      name = 'America/Halifax',
      name = 'America/Havana',
      name = 'America/Hermosillo',
      name = 'America/Indiana/Indianapolis',
      name = 'America/Indiana/Knox',
      name = 'America/Indiana/Marengo',
      name = 'America/Indiana/Petersburg',
      name = 'America/Indiana/Tell_City',
      name = 'America/Indiana/Vevay',
      name = 'America/Indiana/Vincennes',
      name = 'America/Indiana/Winamac',
      name = 'America/Indianapolis',
      name = 'America/Inuvik',
      name = 'America/Iqaluit',
      name = 'America/Jamaica',
      name = 'America/Jujuy',
      name = 'America/Juneau',
      name = 'America/Kentucky/Louisville',
      name = 'America/Kentucky/Monticello',
      name = 'America/Knox_IN',
      name = 'America/Kralendijk',
      name = 'America/La_Paz',
      name = 'America/Lima',
      name = 'America/Los_Angeles',
      name = 'America/Louisville',
      name = 'America/Lower_Princes',
      name = 'America/Maceio',
      name = 'America/Managua',
      name = 'America/Manaus',
      name = 'America/Marigot',
      name = 'America/Martinique',
      name = 'America/Matamoros',
      name = 'America/Mazatlan',
      name = 'America/Mendoza',
      name = 'America/Menominee',
      name = 'America/Merida',
      name = 'America/Metlakatla',
      name = 'America/Mexico_City',
      name = 'America/Miquelon',
      name = 'America/Moncton',
      name = 'America/Monterrey',
      name = 'America/Montevideo',
      name = 'America/Montreal',
      name = 'America/Montserrat',
      name = 'America/Nassau',
      name = 'America/New_York',
      name = 'America/Nipigon',
      name = 'America/Nome',
      name = 'America/Noronha',
      name = 'America/North_Dakota/Beulah',
      name = 'America/North_Dakota/Center',
      name = 'America/North_Dakota/New_Salem',
      name = 'America/Nuuk',
      name = 'America/Ojinaga',
      name = 'America/Panama',
      name = 'America/Pangnirtung',
      name = 'America/Paramaribo',
      name = 'America/Phoenix',
      name = 'America/Port-au-Prince',
      name = 'America/Port_of_Spain',
      name = 'America/Porto_Acre',
      name = 'America/Porto_Velho',
      name = 'America/Puerto_Rico',
      name = 'America/Punta_Arenas',
      name = 'America/Rainy_River',
      name = 'America/Rankin_Inlet',
      name = 'America/Recife',
      name = 'America/Regina',
      name = 'America/Resolute',
      name = 'America/Rio_Branco',
      name = 'America/Rosario',
      name = 'America/Santa_Isabel',
      name = 'America/Santarem',
      name = 'America/Santiago',
      name = 'America/Santo_Domingo',
      name = 'America/Sao_Paulo',
      name = 'America/Scoresbysund',
      name = 'America/Shiprock',
      name = 'America/Sitka',
      name = 'America/St_Barthelemy',
      name = 'America/St_Johns',
      name = 'America/St_Kitts',
      name = 'America/St_Lucia',
      name = 'America/St_Thomas',
      name = 'America/St_Vincent',
      name = 'America/Swift_Current',
      name = 'America/Tegucigalpa',
      name = 'America/Thule',
      name = 'America/Thunder_Bay',
      name = 'America/Tijuana',
      name = 'America/Toronto',
      name = 'America/Tortola',
      name = 'America/Vancouver',
      name = 'America/Virgin',
      name = 'America/Whitehorse',
      name = 'America/Winnipeg',
      name = 'America/Yakutat',
      name = 'America/Yellowknife',
      name = 'Antarctica/Casey',
      name = 'Antarctica/Davis',
      name = 'Antarctica/DumontDUrville',
      name = 'Antarctica/Macquarie',
      name = 'Antarctica/Mawson',
      name = 'Antarctica/McMurdo',
      name = 'Antarctica/Palmer',
      name = 'Antarctica/Rothera',
      name = 'Antarctica/South_Pole',
      name = 'Antarctica/Syowa',
      name = 'Antarctica/Troll',
      name = 'Antarctica/Vostok',
      name = 'Arctic/Longyearbyen',
      name = 'Asia/Aden',
      name = 'Asia/Almaty',
      name = 'Asia/Amman',
      name = 'Asia/Anadyr',
      name = 'Asia/Aqtau',
      name = 'Asia/Aqtobe',
      name = 'Asia/Ashgabat',
      name = 'Asia/Ashkhabad',
      name = 'Asia/Atyrau',
      name = 'Asia/Baghdad',
      name = 'Asia/Bahrain',
      name = 'Asia/Baku',
      name = 'Asia/Bangkok',
      name = 'Asia/Barnaul',
      name = 'Asia/Beirut',
      name = 'Asia/Bishkek',
      name = 'Asia/Brunei',
      name = 'Asia/Calcutta',
      name = 'Asia/Chita',
      name = 'Asia/Choibalsan',
      name = 'Asia/Chongqing',
      name = 'Asia/Chungking',
      name = 'Asia/Colombo',
      name = 'Asia/Dacca',
      name = 'Asia/Damascus',
      name = 'Asia/Dhaka',
      name = 'Asia/Dili',
      name = 'Asia/Dubai',
      name = 'Asia/Dushanbe',
      name = 'Asia/Famagusta',
      name = 'Asia/Gaza',
      name = 'Asia/Harbin',
      name = 'Asia/Hebron',
      name = 'Asia/Ho_Chi_Minh',
      name = 'Asia/Hong_Kong',
      name = 'Asia/Hovd',
      name = 'Asia/Irkutsk',
      name = 'Asia/Istanbul',
      name = 'Asia/Jakarta',
      name = 'Asia/Jayapura',
      name = 'Asia/Jerusalem',
      name = 'Asia/Kabul',
      name = 'Asia/Kamchatka',
      name = 'Asia/Karachi',
      name = 'Asia/Kashgar',
      name = 'Asia/Kathmandu',
      name = 'Asia/Katmandu',
      name = 'Asia/Khandyga',
      name = 'Asia/Kolkata',
      name = 'Asia/Krasnoyarsk',
      name = 'Asia/Kuala_Lumpur',
      name = 'Asia/Kuching',
      name = 'Asia/Kuwait',
      name = 'Asia/Macao',
      name = 'Asia/Macau',
      name = 'Asia/Magadan',
      name = 'Asia/Makassar',
      name = 'Asia/Manila',
      name = 'Asia/Muscat',
      name = 'Asia/Nicosia',
      name = 'Asia/Novokuznetsk',
      name = 'Asia/Novosibirsk',
      name = 'Asia/Omsk',
      name = 'Asia/Oral',
      name = 'Asia/Phnom_Penh',
      name = 'Asia/Pontianak',
      name = 'Asia/Pyongyang',
      name = 'Asia/Qatar',
      name = 'Asia/Qostanay',
      name = 'Asia/Qyzylorda',
      name = 'Asia/Rangoon',
      name = 'Asia/Riyadh',
      name = 'Asia/Saigon',
      name = 'Asia/Sakhalin',
      name = 'Asia/Samarkand',
      name = 'Asia/Seoul',
      name = 'Asia/Shanghai',
      name = 'Asia/Singapore',
      name = 'Asia/Srednekolymsk',
      name = 'Asia/Taipei',
      name = 'Asia/Tashkent',
      name = 'Asia/Tbilisi',
      name = 'Asia/Tehran',
      name = 'Asia/Tel_Aviv',
      name = 'Asia/Thimbu',
      name = 'Asia/Thimphu',
      name = 'Asia/Tokyo',
      name = 'Asia/Tomsk',
      name = 'Asia/Ujung_Pandang',
      name = 'Asia/Ulaanbaatar',
      name = 'Asia/Ulan_Bator',
      name = 'Asia/Urumqi',
      name = 'Asia/Ust-Nera',
      name = 'Asia/Vientiane',
      name = 'Asia/Vladivostok',
      name = 'Asia/Yakutsk',
      name = 'Asia/Yangon',
      name = 'Asia/Yekaterinburg',
      name = 'Asia/Yerevan',
      name = 'Atlantic/Azores',
      name = 'Atlantic/Bermuda',
      name = 'Atlantic/Canary',
      name = 'Atlantic/Cape_Verde',
      name = 'Atlantic/Faeroe',
      name = 'Atlantic/Faroe',
      name = 'Atlantic/Jan_Mayen',
      name = 'Atlantic/Madeira',
      name = 'Atlantic/Reykjavik',
      name = 'Atlantic/South_Georgia',
      name = 'Atlantic/St_Helena',
      name = 'Atlantic/Stanley',
      name = 'Australia/ACT',
      name = 'Australia/Adelaide',
      name = 'Australia/Brisbane',
      name = 'Australia/Broken_Hill',
      name = 'Australia/Canberra',
      name = 'Australia/Currie',
      name = 'Australia/Darwin',
      name = 'Australia/Eucla',
      name = 'Australia/Hobart',
      name = 'Australia/LHI',
      name = 'Australia/Lindeman',
      name = 'Australia/Lord_Howe',
      name = 'Australia/Melbourne',
      name = 'Australia/NSW',
      name = 'Australia/North',
      name = 'Australia/Perth',
      name = 'Australia/Queensland',
      name = 'Australia/South',
      name = 'Australia/Sydney',
      name = 'Australia/Tasmania',
      name = 'Australia/Victoria',
      name = 'Australia/West',
      name = 'Australia/Yancowinna',
      name = 'Brazil/Acre',
      name = 'Brazil/DeNoronha',
      name = 'Brazil/East',
      name = 'Brazil/West',
      name = 'CET',
      name = 'CST6CDT',
      name = 'Canada/Atlantic',
      name = 'Canada/Central',
      name = 'Canada/Eastern',
      name = 'Canada/Mountain',
      name = 'Canada/Newfoundland',
      name = 'Canada/Pacific',
      name = 'Canada/Saskatchewan',
      name = 'Canada/Yukon',
      name = 'Chile/Continental',
      name = 'Chile/EasterIsland',
      name = 'Cuba',
      name = 'EET',
      name = 'EST',
      name = 'EST5EDT',
      name = 'Egypt',
      name = 'Eire',
      name = 'Etc/GMT',
      name = 'Etc/GMT+0',
      name = 'Etc/GMT+1',
      name = 'Etc/GMT+10',
      name = 'Etc/GMT+11',
      name = 'Etc/GMT+12',
      name = 'Etc/GMT+2',
      name = 'Etc/GMT+3',
      name = 'Etc/GMT+4',
      name = 'Etc/GMT+5',
      name = 'Etc/GMT+6',
      name = 'Etc/GMT+7',
      name = 'Etc/GMT+8',
      name = 'Etc/GMT+9',
      name = 'Etc/GMT-0',
      name = 'Etc/GMT-1',
      name = 'Etc/GMT-10',
      name = 'Etc/GMT-11',
      name = 'Etc/GMT-12',
      name = 'Etc/GMT-13',
      name = 'Etc/GMT-14',
      name = 'Etc/GMT-2',
      name = 'Etc/GMT-3',
      name = 'Etc/GMT-4',
      name = 'Etc/GMT-5',
      name = 'Etc/GMT-6',
      name = 'Etc/GMT-7',
      name = 'Etc/GMT-8',
      name = 'Etc/GMT-9',
      name = 'Etc/GMT0',
      name = 'Etc/Greenwich',
      name = 'Etc/UCT',
      name = 'Etc/UTC',
      name = 'Etc/Universal',
      name = 'Etc/Zulu',
      name = 'Europe/Amsterdam',
      name = 'Europe/Andorra',
      name = 'Europe/Astrakhan',
      name = 'Europe/Athens',
      name = 'Europe/Belfast',
      name = 'Europe/Belgrade',
      name = 'Europe/Berlin',
      name = 'Europe/Bratislava',
      name = 'Europe/Brussels',
      name = 'Europe/Bucharest',
      name = 'Europe/Budapest',
      name = 'Europe/Busingen',
      name = 'Europe/Chisinau',
      name = 'Europe/Copenhagen',
      name = 'Europe/Dublin',
      name = 'Europe/Gibraltar',
      name = 'Europe/Guernsey',
      name = 'Europe/Helsinki',
      name = 'Europe/Isle_of_Man',
      name = 'Europe/Istanbul',
      name = 'Europe/Jersey',
      name = 'Europe/Kaliningrad',
      name = 'Europe/Kiev',
      name = 'Europe/Kirov',
      name = 'Europe/Lisbon',
      name = 'Europe/Ljubljana',
      name = 'Europe/London',
      name = 'Europe/Luxembourg',
      name = 'Europe/Madrid',
      name = 'Europe/Malta',
      name = 'Europe/Mariehamn',
      name = 'Europe/Minsk',
      name = 'Europe/Monaco',
      name = 'Europe/Moscow',
      name = 'Europe/Nicosia',
      name = 'Europe/Oslo',
      name = 'Europe/Paris',
      name = 'Europe/Podgorica',
      name = 'Europe/Prague',
      name = 'Europe/Riga',
      name = 'Europe/Rome',
      name = 'Europe/Samara',
      name = 'Europe/San_Marino',
      name = 'Europe/Sarajevo',
      name = 'Europe/Saratov',
      name = 'Europe/Simferopol',
      name = 'Europe/Skopje',
      name = 'Europe/Sofia',
      name = 'Europe/Stockholm',
      name = 'Europe/Tallinn',
      name = 'Europe/Tirane',
      name = 'Europe/Tiraspol',
      name = 'Europe/Ulyanovsk',
      name = 'Europe/Uzhgorod',
      name = 'Europe/Vaduz',
      name = 'Europe/Vatican',
      name = 'Europe/Vienna',
      name = 'Europe/Vilnius',
      name = 'Europe/Volgograd',
      name = 'Europe/Warsaw',
      name = 'Europe/Zagreb',
      name = 'Europe/Zaporozhye',
      name = 'Europe/Zurich',
      name = 'Factory',
      name = 'GB',
      name = 'GB-Eire',
      name = 'GMT',
      name = 'GMT+0',
      name = 'GMT-0',
      name = 'GMT0',
      name = 'Greenwich',
      name = 'HST',
      name = 'Hongkong',
      name = 'Iceland',
      name = 'Indian/Antananarivo',
      name = 'Indian/Chagos',
      name = 'Indian/Christmas',
      name = 'Indian/Cocos',
      name = 'Indian/Comoro',
      name = 'Indian/Kerguelen',
      name = 'Indian/Mahe',
      name = 'Indian/Maldives',
      name = 'Indian/Mauritius',
      name = 'Indian/Mayotte',
      name = 'Indian/Reunion',
      name = 'Iran',
      name = 'Israel',
      name = 'Jamaica',
      name = 'Japan',
      name = 'Kwajalein',
      name = 'Libya',
      name = 'MET',
      name = 'MST',
      name = 'MST7MDT',
      name = 'Mexico/BajaNorte',
      name = 'Mexico/BajaSur',
      name = 'Mexico/General',
      name = 'NZ',
      name = 'NZ-CHAT',
      name = 'Navajo',
      name = 'PRC',
      name = 'PST8PDT',
      name = 'Pacific/Apia',
      name = 'Pacific/Auckland',
      name = 'Pacific/Bougainville',
      name = 'Pacific/Chatham',
      name = 'Pacific/Chuuk',
      name = 'Pacific/Easter',
      name = 'Pacific/Efate',
      name = 'Pacific/Enderbury',
      name = 'Pacific/Fakaofo',
      name = 'Pacific/Fiji',
      name = 'Pacific/Funafuti',
      name = 'Pacific/Galapagos',
      name = 'Pacific/Gambier',
      name = 'Pacific/Guadalcanal',
      name = 'Pacific/Guam',
      name = 'Pacific/Honolulu',
      name = 'Pacific/Johnston',
      name = 'Pacific/Kiritimati',
      name = 'Pacific/Kosrae',
      name = 'Pacific/Kwajalein',
      name = 'Pacific/Majuro',
      name = 'Pacific/Marquesas',
      name = 'Pacific/Midway',
      name = 'Pacific/Nauru',
      name = 'Pacific/Niue',
      name = 'Pacific/Norfolk',
      name = 'Pacific/Noumea',
      name = 'Pacific/Pago_Pago',
      name = 'Pacific/Palau',
      name = 'Pacific/Pitcairn',
      name = 'Pacific/Pohnpei',
      name = 'Pacific/Ponape',
      name = 'Pacific/Port_Moresby',
      name = 'Pacific/Rarotonga',
      name = 'Pacific/Saipan',
      name = 'Pacific/Samoa',
      name = 'Pacific/Tahiti',
      name = 'Pacific/Tarawa',
      name = 'Pacific/Tongatapu',
      name = 'Pacific/Truk',
      name = 'Pacific/Wake',
      name = 'Pacific/Wallis',
      name = 'Pacific/Yap',
      name = 'Poland',
      name = 'Portugal',
      name = 'ROC',
      name = 'ROK',
      name = 'Singapore',
      name = 'Turkey',
      name = 'UCT',
      name = 'US/Alaska',
      name = 'US/Aleutian',
      name = 'US/Arizona',
      name = 'US/Central',
      name = 'US/East-Indiana',
      name = 'US/Eastern',
      name = 'US/Hawaii',
      name = 'US/Indiana-Starke',
      name = 'US/Michigan',
      name = 'US/Mountain',
      name = 'US/Pacific',
      name = 'US/Samoa',
      name = 'UTC',
      name = 'Universal',
      name = 'W-SU',
      name = 'WET',
      name = 'Zulu'
    ]
    return list
  },
  // 广告套利-报告-获取选项
  getGroupByList(){
    let list = [
      {
          "count": 0,
          "label": "Affiliate Network",
          "code": "affiliateNetworkID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Bot Score",
          "code": "botScore",
          "description": ""
      },
      {
          "count": 0,
          "label": "Browser",
          "code": "deviceBrowser",
          "description": ""
      },
      {
          "count": 0,
          "label": "Browser Version",
          "code": "deviceBrowserVersion",
          "description": ""
      },
      {
          "count": 0,
          "label": "Campaigns",
          "code": "campaignID",
          "description": ""
      },
      {
          "count": 0,
          "label": "City",
          "code": "locationCity",
          "description": ""
      },
      {
          "count": 0,
          "label": "ClickID",
          "code": "clickID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Connection Type",
          "code": "connectionType",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 1",
          "code": "param1",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 10",
          "code": "param10",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 11",
          "code": "param11",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 12",
          "code": "param12",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 13",
          "code": "param13",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 14",
          "code": "param14",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 15",
          "code": "param15",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 16",
          "code": "param16",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 17",
          "code": "param17",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 18",
          "code": "param18",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 19",
          "code": "param19",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 2",
          "code": "param2",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 20",
          "code": "param20",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 3",
          "code": "param3",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 4",
          "code": "param4",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 5",
          "code": "param5",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 6",
          "code": "param6",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 7",
          "code": "param7",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 8",
          "code": "param8",
          "description": ""
      },
      {
          "count": 0,
          "label": "Conversion Param 9",
          "code": "param9",
          "description": ""
      },
      {
          "count": 0,
          "label": "Country",
          "code": "locationCountry",
          "description": ""
      },
      {
          "count": 0,
          "label": "Date",
          "code": "date",
          "description": ""
      },
      {
          "count": 0,
          "label": "Date Time",
          "code": "dateTime",
          "description": ""
      },
      {
          "count": 0,
          "label": "Day of week",
          "code": "dayOfWeek",
          "description": ""
      },
      {
          "count": 0,
          "label": "Device Brand",
          "code": "deviceBrand",
          "description": ""
      },
      {
          "count": 0,
          "label": "Device Model",
          "code": "deviceModel",
          "description": ""
      },
      {
          "count": 0,
          "label": "Device Type",
          "code": "deviceType",
          "description": ""
      },
      {
          "count": 0,
          "label": "ExternalID",
          "code": "externalID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Flow",
          "code": "flowID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Hour of day",
          "code": "hourOfDay",
          "description": ""
      },
      {
          "count": 0,
          "label": "IP",
          "code": "connectionIP",
          "description": ""
      },
      {
          "count": 0,
          "label": "ISP/Carrier",
          "code": "connectionISP",
          "description": ""
      },
      {
          "count": 0,
          "label": "Keyword",
          "code": "queryStringRotation",
          "description": ""
      },
      {
          "count": 0,
          "label": "Lander",
          "code": "landingID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Language",
          "code": "deviceMainLanguage",
          "description": ""
      },
      {
          "count": 0,
          "label": "Month",
          "code": "startOfMonth",
          "description": ""
      },
      {
          "count": 0,
          "label": "Node",
          "code": "nodeID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Nodes Path",
          "code": "nodesPath",
          "description": ""
      },
      {
          "count": 0,
          "label": "Offers",
          "code": "offerID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Operating System",
          "code": "deviceOS",
          "description": ""
      },
      {
          "count": 0,
          "label": "Operating System Version",
          "code": "deviceOsVersion",
          "description": ""
      },
      {
          "count": 0,
          "label": "Referrer",
          "code": "connectionReferrer",
          "description": ""
      },
      {
          "count": 0,
          "label": "Referrer domain",
          "code": "connectionReferrerDomain",
          "description": ""
      },
      {
          "count": 0,
          "label": "Region",
          "code": "locationRegion",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 1",
          "code": "trackingField1",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 10",
          "code": "trackingField10",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 11",
          "code": "trackingField11",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 12",
          "code": "trackingField12",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 13",
          "code": "trackingField13",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 14",
          "code": "trackingField14",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 15",
          "code": "trackingField15",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 16",
          "code": "trackingField16",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 17",
          "code": "trackingField17",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 18",
          "code": "trackingField18",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 19",
          "code": "trackingField19",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 2",
          "code": "trackingField2",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 20",
          "code": "trackingField20",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 3",
          "code": "trackingField3",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 4",
          "code": "trackingField4",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 5",
          "code": "trackingField5",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 6",
          "code": "trackingField6",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 7",
          "code": "trackingField7",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 8",
          "code": "trackingField8",
          "description": ""
      },
      {
          "count": 0,
          "label": "Tracking field 9",
          "code": "trackingField9",
          "description": ""
      },
      {
          "count": 0,
          "label": "Traffic Sources",
          "code": "trafficSourceID",
          "description": ""
      },
      {
          "count": 0,
          "label": "Unreplaced Keyword",
          "code": "queryStringRotationUnreplaced",
          "description": ""
      },
      {
          "count": 0,
          "label": "User Agent",
          "code": "deviceUserAgent",
          "description": ""
      },
      {
          "count": 0,
          "label": "VisitID",
          "code": "visitID",
          "description": ""
      }
  ];
    return list
  },
}
export function getTableHeader() {
    return {
        textAlign: "center",
        background: "#f8f8f8",
        color: "#232323",
    }
}
export function formatDate(timestamp = Date.now(), formatStr = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(timestamp);

    const map = {
        YYYY: date.getFullYear(),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        DD: String(date.getDate()).padStart(2, '0'),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0'),
    };

    return formatStr.replace(/YYYY|MM|DD|HH|mm|ss/g, match => map[match]);
}
